import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Layout, Menu, Dropdown } from 'antd';
import { SidebarIcon } from '../../.././core/utils/general';
import { subRoutes, subDivisions } from '../../.././core/utils/constants/constants';
import OrgDisplay from '../.././shared/OrgDisplay';
import sitemap from '../../routes/sitemap';
import {
  logo,
  subMenu,
  itemNotSelected,
  spanNotSelected,
  blackSpanNotSelected,
} from '../../shared/globalStyling/style';
import { determineUserAccess } from '../../../core/permissions/userLevelAccess';
//import ChatwootWidget from "../../../core/shared/ChatwootWidget";
//import { determineUserAccess } from "../../../core/permissions/userLevelAccess";
const { Sider } = Layout;
const { Item, SubMenu, ItemGroup } = Menu;

const getSpanStyle = (sidebarColor) => {
  if (!sidebarColor) return spanNotSelected;

  let cleanedColor = sidebarColor.startsWith('#') ? sidebarColor.slice(1) : sidebarColor;
  let [r, g, b] = cleanedColor.match(/.{1,2}/g).map((hex) => parseInt(hex, 16));
  const isWhite = r >= 200 && g >= 200 && b >= 200;

  return isWhite ? blackSpanNotSelected : spanNotSelected;
};

const shouldShowSubCategory = (features, subDivisions) => {
  const existsInArray = (el, arr) => arr.includes(el);
  return features.some((feature) => existsInArray(feature, subDivisions));
};

const transformURL = (url, feature) => {
  if (url !== undefined && url !== -1) return url;

  // The switch case is intentional in anticipation that there will be more features to be renamed.
  // If in the future, there are more features to be renamed, we can add more cases here.
  switch (feature) {
    case 'DEMOGRAPHIC':
      return '/demograph';
    case 'CREATE_TASK':
      return '/tasks/form';
    case 'SYSTEM_ALERTS':
      return '/system-alerts';
    case 'INVOICES':
      return '/invoice';
    default:
      return `/${feature.toLowerCase()}`;
  }
};

const transformFeatureName = (feature) => {
  switch (feature) {
    case 'DEMOGRAPHIC':
      return ' Demograph';
    case 'AUDIENCES':
      return ' Audiences';
    case 'LOCATIONS':
      return ' Locations';
    case 'ADVERTISER':
      return ' Advertiser';
    case 'PUBLISHER':
      return ' Publisher';
    case 'SIGNAL TAGS':
      return ' Signal Tags';
    case 'INVOICES':
      return ' Invoices';
    case 'AUDIENCE':
      return ' Audience';
    case 'TARGETING':
      return ' Targeting';
    case 'TAGS':
      return ' Tags';
    case 'CREATIVES':
      return ' Creatives';
    case 'RETAILS_STORES':
      return ' Retail Stores';
    case 'SETTINGS':
      return ' Settings';
    case 'KNOWLEDGE_BASE':
      return ' Knowledge Base';
    case 'API_DOCS':
      return ' API Docs';
    case 'ORGS':
      return ' Organization';
    case 'TASKS':
      return ' Tasks';
    case 'CREATE_TASK':
      return ' Create Task';
    case 'SEO':
      return ' Seo Domains';
    case 'SYSTEM_ALERTS':
      return ' System Alerts';
    default:
      return feature;
  }
};

const accessibleFeatures = (
  allFeatures,
  features,
  rootPath,
  collapsed,
  subMenuSelected,
  setSubMenuSelected,
  sidebarColor,
  hasAccessAll = false, //Special Condition to show all feature without checking if user has access
  orgLevel,
  urlLink,
  parentOrgLevel,
  billing
) => {
  return allFeatures
    .filter((feature) => {
      if (hasAccessAll) return true;
      return features.indexOf(feature) > -1;
    })
    .map((feature, i) => {
      if (
        (feature === 'INVOICES' && !billing) ||
        feature === 'LIBRARY' ||
        feature === 'HOME' ||
        feature === 'USERS'
      ) {
        return null;
      }
      const selected =
        feature === rootPath && feature === 'CREATE_TASK' ? 'ant-menu-item-selected' : null;
      const keySubRoutes = Object.keys(subRoutes).find((key) => key === feature);
      const featureName =
        feature.replace(/_/g, ' ').charAt(0) + feature.replace(/_/g, ' ').slice(1).toLowerCase();
      const siteMapIndex = Object.values(sitemap).findIndex((sitemapValues) => {
        return sitemapValues === featureName;
      });

      const siteMapURL = Object.keys(sitemap)[siteMapIndex];
      return (
        <React.Fragment key={i}>
          {keySubRoutes ? (
            <SubMenu
              key={`${i}-submenu-${feature}`}
              onTitleClick={() => setSubMenuSelected(true)}
              popupClassName="vertical-sidebar-submenu"
              popupStyle={{ background: 'transparent' }}
              title={
                <span>
                  {collapsed ? (
                    <Link
                      style={{ color: 'rgba(255, 255, 255, 0.65)' }}
                      to={'/' + feature.toLowerCase()}
                    >
                      <SidebarIcon type={feature} />
                    </Link>
                  ) : (
                    <>
                      <Link style={subMenu} to={'/' + feature.toLowerCase()}>
                        <SidebarIcon type={feature} />
                        <span>
                          {feature === 'CAMPAIGNS'
                            ? 'Display'
                            : feature.replace(/_/g, ' ').charAt(0) +
                              feature.replace(/_/g, ' ').slice(1).toLowerCase()}
                        </span>
                      </Link>
                    </>
                  )}
                </span>
              }
            >
              {subRoutes[keySubRoutes].map((subRoute) => {
                const sitemapSubRouteIndex = Object.values(sitemap).findIndex(
                  (sitemapValues) => sitemapValues === subRoute
                );
                const subRouteURL = Object.keys(sitemap)[sitemapSubRouteIndex];
                let subName = subRoute;
                switch (subRoute) {
                  case 'Paid Search Campaign':
                    subName = 'Campaign';
                    break;
                  case 'SEO Domains':
                    subName = 'Domains';
                    break;
                  case 'Paid Search Reports':
                    subName = 'Reports';
                    break;
                  case 'SEO Reports':
                    subName = 'Reports';
                    break;
                  default:
                }
                if (orgLevel === 'STANDARD' && subRoute === 'Overview') return null;

                return (
                  <Item key={subRoute}>
                    <Link to={subRouteURL ? subRouteURL : '/home'}>
                      <span>{subName}</span>
                    </Link>
                  </Item>
                );
              })}
            </SubMenu>
          ) : (
            <Item
              key={feature}
              style={!subMenuSelected ? {} : itemNotSelected}
              className={selected}
              onClick={() => setSubMenuSelected(false)}
            >
              <Link
                to={transformURL(siteMapURL, feature)}
                onClick={() => {
                  if (transformURL(siteMapURL, feature) === '/demograph') {
                    window.location.href = '/demograph';
                  }
                }}
              >
                <SidebarIcon type={feature} />
                <span style={!subMenuSelected ? {} : getSpanStyle(sidebarColor)}>
                  {transformFeatureName(feature)}
                </span>
              </Link>
            </Item>
          )}
        </React.Fragment>
      );
    });
};

const renderCollapsedMenu = (
  divisions,
  features,
  rootPath,
  collapsed,
  subMenuSelected,
  setSubMenuSelected,
  sidebarColor,
  isSelfService,
  billing,
  orgLevel,
  parentOrgLevel,
  urlLink
) => {
  return (
    <ItemGroup key={'collapsedMenu'}>
      {divisions.map((division, i) => {
        if (division === 'ATTENTION SIGNALS') {
          const hasPermission = features.includes('EDITORIAL');
          if (!hasPermission) return null;
          return accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel,
            urlLink,
            parentOrgLevel,
            billing
          );
        } else if (division === 'LIBRARY') {
          if (!isSelfService) return null;
          return accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel,
            parentOrgLevel,
            urlLink,
            billing
          );
        } else if (division === 'TASK MANAGEMENT') {
          const hasPermission = features.includes('TASK_MANAGEMENT');
          if (!hasPermission) return null;
          return accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true
          );
        } else if (division === 'ADMIN') {
          let subDiv = subDivisions[division];

          const hasPermission = features.includes('ORGS');
          const hasSystemAlertsPermission = features.includes('SYSTEM_ALERTS');

          if (!hasPermission) {
            if (
              (orgLevel === 'STANDARD' && urlLink && parentOrgLevel === 'CHANNEL_PARTNER') ||
              orgLevel === 'CHANNEL_PARTNER'
            ) {
              subDiv = ['KNOWLEDGE_BASE', 'SETTINGS'];
            } else {
              subDiv = ['SETTINGS'];
            }
          } else {
            if (
              (orgLevel === 'STANDARD' && urlLink && parentOrgLevel === 'CHANNEL_PARTNER') ||
              orgLevel === 'CHANNEL_PARTNER'
            ) {
              subDiv = ['KNOWLEDGE_BASE', 'SETTINGS', 'ORGS'];
            } else {
              subDiv = ['SETTINGS', 'ORGS'];
            }
          }

          // Add SYSTEM_ALERTS if user has permission
          if (hasSystemAlertsPermission && !subDiv.includes('SYSTEM_ALERTS')) {
            subDiv.push('SYSTEM_ALERTS');
          }

          if (!hasPermission && !hasSystemAlertsPermission) return null;
          return accessibleFeatures(
            subDiv,
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel,
            urlLink,
            parentOrgLevel,
            billing
          );
        } else {
          return accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            false,
            orgLevel,
            urlLink,
            parentOrgLevel,
            billing
          );
        }
      })}
    </ItemGroup>
  );
};

const renderExtendedMenu = (
  divisions,
  features,
  rootPath,
  collapsed,
  subMenuSelected,
  setSubMenuSelected,
  sidebarColor,
  isSelfService,
  billing,
  orgLevel,
  parentOrgLevel,
  urlLink
) => {
  return divisions.map((division, i) => {
    if (division === 'ATTENTION SIGNALS') {
      const hasPermission = features.includes('EDITORIAL');
      if (!hasPermission) return null;
      return (
        <ItemGroup key={division} title={division} style={{ width: '100%', marginBottom: '10%' }}>
          {accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel,
            urlLink,
            parentOrgLevel,
            billing
          )}
        </ItemGroup>
      );
    }

    if (division === 'LIBRARY') {
      if (!isSelfService) return null;
      return (
        <ItemGroup key={division} title={division} style={{ width: '100%', marginBottom: '10%' }}>
          {accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel,
            parentOrgLevel,
            urlLink,
            billing
          )}
        </ItemGroup>
      );
    }

    if (division === 'TASK MANAGEMENT') {
      const hasPermission = features.includes('TASK_MANAGEMENT');
      if (!hasPermission) return null;
      return (
        <ItemGroup key={division} title={division} style={{ width: '100%', marginBottom: '10%' }}>
          {accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true
          )}
        </ItemGroup>
      );
    }

    if (division === 'ADMIN') {
      let subDiv = subDivisions[division];

      const hasPermission = features.includes('ORGS');
      const hasSystemAlertsPermission = features.includes('SYSTEM_ALERTS');

      if (!hasPermission) {
        if (
          (orgLevel === 'STANDARD' && urlLink && parentOrgLevel === 'CHANNEL_PARTNER') ||
          orgLevel === 'CHANNEL_PARTNER'
        ) {
          subDiv = ['KNOWLEDGE_BASE', 'SETTINGS'];
        } else {
          subDiv = ['SETTINGS'];
        }
      } else {
        if (
          (orgLevel === 'STANDARD' && urlLink && parentOrgLevel === 'CHANNEL_PARTNER') ||
          orgLevel === 'CHANNEL_PARTNER'
        ) {
          subDiv = ['KNOWLEDGE_BASE', 'SETTINGS', 'ORGS'];
        } else {
          subDiv = ['SETTINGS', 'ORGS'];
        }
      }

      // Add SYSTEM_ALERTS if user has permission
      if (hasSystemAlertsPermission && !subDiv.includes('SYSTEM_ALERTS')) {
        subDiv.push('SYSTEM_ALERTS');
      }

      if (!hasPermission && !hasSystemAlertsPermission) return null;
      return (
        <ItemGroup key={division} title={division} style={{ width: '100%', marginBottom: '10%' }}>
          {accessibleFeatures(
            subDiv,
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel,
            urlLink,
            parentOrgLevel,
            billing
          )}
        </ItemGroup>
      );
    }

    return division === 'MAIN' ? (
      <ItemGroup key={division} title={division} style={{ width: '100%', marginBottom: '10%' }}>
        {accessibleFeatures(
          subDivisions[division],
          features,
          rootPath,
          collapsed,
          subMenuSelected,
          setSubMenuSelected,
          sidebarColor,
          false,
          orgLevel,
          urlLink,
          parentOrgLevel,
          billing
        )}
      </ItemGroup>
    ) : shouldShowSubCategory(features, subDivisions[division]) ? (
      <ItemGroup key={division} title={division} style={{ width: '100%', marginBottom: '10%' }}>
        {accessibleFeatures(
          subDivisions[division],
          features,
          rootPath,
          collapsed,
          subMenuSelected,
          setSubMenuSelected,
          false,
          orgLevel,
          urlLink,
          parentOrgLevel,
          billing
        )}
      </ItemGroup>
    ) : (
      ''
    );
  });
};

// We are assuming that we always want to show at least the "MAIN" subcategory
const renderSubCategoriesAndFeatures = (
  divisions,
  features,
  rootPath,
  collapsed,
  subMenuSelected,
  setSubMenuSelected,
  sidebarColor,
  isSelfService,
  billing,
  orgLevel,
  urlLink,
  parentOrgLevel
) => {
  return false
    ? renderCollapsedMenu(
        divisions,
        features,
        rootPath,
        collapsed,
        subMenuSelected,
        setSubMenuSelected,
        sidebarColor,
        isSelfService,
        billing,
        orgLevel,
        urlLink,
        parentOrgLevel
      )
    : renderExtendedMenu(
        divisions,
        features,
        rootPath,
        collapsed,
        subMenuSelected,
        setSubMenuSelected,
        sidebarColor,
        isSelfService,
        billing,
        orgLevel,
        urlLink,
        parentOrgLevel
      );
};

const Sidebar = (props) => {
  const userPermission = determineUserAccess(props.currentUser.permission);
  const orgLevel = props.currentUser.role.org.level;

  let urlLink;
  let parentOrgLevel = null;
  let parentOrg = props.currentUser.role.org.parentOrg;

  if (parentOrg.length) {
    urlLink = parentOrg[parentOrg.length - 1].advertiserKnowledgeBaseURL;
    parentOrgLevel = parentOrg[parentOrg.length - 1].level;
  }

  const { isSelfService, billing } = userPermission;

  const { collapsed } = props.state;
  const [subMenuSelected, setSubMenuSelected] = useState(false);
  const [logoKey, setLogoKey] = useState(props.logo ? props.logo.key : null);
  const [defaultLogoKey, setDefaultLogoKey] = useState(props.logo ? props.logo.key : null);
  const { features, location, toggleSideBar } = props;

  // Mobile breakpoint detection
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const rootPath = location.pathname.split('/')[1].toUpperCase();
  const divisions = Object.keys(subDivisions);
  const params = new URLSearchParams(props.location.search);
  let sidebarColor;
  //Listen for changes on local storage to update the logo on the sidebar
  window.addEventListener('imageKey', () => {
    const tempImage = localStorage.getItem('imageKey');
    if (tempImage) {
      setLogoKey(tempImage);
      localStorage.removeItem('imageKey');
    }
  });
  useEffect(() => {
    //Update logo key if the logo changes. This usually happens during preview advertiser
    if (props.logo && defaultLogoKey !== props.logo.key) {
      setDefaultLogoKey(props.logo.key);
      setLogoKey(props.logo.key);
    } else if (!props.logo && defaultLogoKey !== null) {
      //Consider the case where the org has no logo.
      setDefaultLogoKey(null);
      setLogoKey(null);
    }
  }, [defaultLogoKey, props.logo]);

  // Handle window resize for responsive breakpoints
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  let sidebarIsGradient = false;
  let sidebarGradientStart = '#00baff';
  let sidebarGradientEnd = '#7240e9';

  if (props && props.themeData && props.themeData.getOrgThemeConfig) {
    sidebarColor = props.themeData.getOrgThemeConfig.sidebarColor;
    sidebarIsGradient = props.themeData.getOrgThemeConfig.sidebarIsGradient || false;
    sidebarGradientStart = props.themeData.getOrgThemeConfig.sidebarGradientStart || '#00baff';
    sidebarGradientEnd = props.themeData.getOrgThemeConfig.sidebarGradientEnd || '#7240e9';
  }

  // Build the background style - use gradient if enabled, otherwise solid color
  const sidebarBackground = sidebarIsGradient
    ? `linear-gradient(180deg, ${sidebarGradientStart} 0%, ${sidebarGradientEnd} 100%)`
    : sidebarColor || '#001529';

  if (params.get('showNewSegments') === 'true') {
    window.localStorage.setItem('showNewSegments', true);
  }

  if (params.get('showNewSegments') === 'false') {
    window.localStorage.removeItem('showNewSegments');
  }

  if (props.horizontalNavigation) {
    // Build menu item for a single feature
    const buildFeatureMenuItem = (feature) => {
      const keySubRoutes = Object.keys(subRoutes).find((key) => key === feature);

      // Skip certain features
      if (feature === 'LIBRARY' || feature === 'HOME' || feature === 'USERS') {
        return null;
      }

      if (keySubRoutes) {
        // Feature has sub-routes - create nested SubMenu
        const subRouteItems = subRoutes[keySubRoutes].map((subRoute) => {
          const sitemapSubRouteIndex = Object.values(sitemap).findIndex(
            (sitemapValues) => sitemapValues === subRoute
          );
          const subRouteURL = Object.keys(sitemap)[sitemapSubRouteIndex];
          return (
            <Menu.Item key={subRoute}>
              <Link to={subRouteURL || '/home'}>{subRoute}</Link>
            </Menu.Item>
          );
        });

        return (
          <Menu.SubMenu
            key={`feature-${feature}`}
            popupClassName="sidebar-gradient-submenu"
            popupStyle={{
              background: sidebarBackground,
              backgroundColor: sidebarIsGradient ? 'transparent' : sidebarColor,
            }}
            title={
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <SidebarIcon type={feature} />
                <span>{transformFeatureName(feature)}</span>
              </span>
            }
          >
            {subRouteItems}
          </Menu.SubMenu>
        );
      } else {
        // Leaf feature - simple menu item
        return (
          <Menu.Item key={feature}>
            <Link to={transformURL(undefined, feature)}>
              <SidebarIcon type={feature} />
              <span style={{ marginLeft: '8px' }}>{transformFeatureName(feature)}</span>
            </Link>
          </Menu.Item>
        );
      }
    };

    // Build division dropdown with all its features
    const buildDivisionMenu = (division) => {
      let featuresToShow = division === 'ADMIN' ? getAdminSubDiv() : subDivisions[division];

      const featureMenuItems = featuresToShow
        .map((feature) => buildFeatureMenuItem(feature))
        .filter((item) => item !== null);

      if (featureMenuItems.length === 0) return null;

      // Create dropdown menu with features
      const dropdownMenu = (
        <Menu theme="dark" style={{ background: sidebarBackground, borderRadius: '4px' }}>
          {featureMenuItems}
        </Menu>
      );

      return (
        <Dropdown
          key={`division-${division}`}
          overlay={dropdownMenu}
          trigger={['hover']}
          placement="bottomCenter"
          overlayClassName="division-dropdown-overlay"
        >
          <div
            style={{
              cursor: 'pointer',
              padding: '0 12px',
              color: 'rgba(255, 255, 255, 0.85)',
              display: 'flex',
              alignItems: 'center',
              height: '46px',
              userSelect: 'none',
            }}
          >
            {division}
          </div>
        </Dropdown>
      );
    };

    // Get divisions to render based on permissions
    const getDivisionsToRender = () => {
      const divisionsToRender = [];
      const divisionOrder = ['MAIN', 'ATTENTION SIGNALS', 'LIBRARY', 'TASK MANAGEMENT', 'ADMIN'];

      divisionOrder.forEach((division) => {
        // Skip divisions based on permission checks
        if (division === 'ATTENTION SIGNALS' && !features.includes('EDITORIAL')) {
          return;
        }
        if (division === 'LIBRARY' && !isSelfService) {
          return;
        }
        if (division === 'TASK MANAGEMENT' && !features.includes('TASK_MANAGEMENT')) {
          return;
        }
        // MAIN and ADMIN always render
        divisionsToRender.push(division);
      });

      return divisionsToRender;
    };

    // Get admin sub-features
    const getAdminSubDiv = () => {
      let subDiv = subDivisions['ADMIN'];
      const hasOrgPermission = features.includes('ORGS');
      const hasSystemAlertsPermission = features.includes('SYSTEM_ALERTS');

      if (!hasOrgPermission) {
        if (
          (orgLevel === 'STANDARD' && urlLink && parentOrgLevel === 'CHANNEL_PARTNER') ||
          orgLevel === 'CHANNEL_PARTNER'
        ) {
          subDiv = ['KNOWLEDGE_BASE', 'SETTINGS'];
        } else {
          subDiv = ['SETTINGS'];
        }
      } else {
        if (
          (orgLevel === 'STANDARD' && urlLink && parentOrgLevel === 'CHANNEL_PARTNER') ||
          orgLevel === 'CHANNEL_PARTNER'
        ) {
          subDiv = ['KNOWLEDGE_BASE', 'SETTINGS', 'ORGS'];
        } else {
          subDiv = ['SETTINGS', 'ORGS'];
        }
      }

      // Add SYSTEM_ALERTS if user has permission
      if (hasSystemAlertsPermission && !subDiv.includes('SYSTEM_ALERTS')) {
        subDiv.push('SYSTEM_ALERTS');
      }

      return subDiv;
    };

    if (isMobile) return null;

    return (
      <div
        style={{
          background: sidebarIsGradient
            ? `linear-gradient(90deg, ${sidebarGradientStart} 0%, ${sidebarGradientEnd} 100%)`
            : sidebarBackground,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          padding: '8px 16px',
          minHeight: '59px',
          flexWrap: 'wrap',
          position: 'relative',
          zIndex: 99,
        }}
      >
        {/* Logo thumbnail on the left */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginRight: '16px',
            height: '43px',
            overflow: 'hidden',
            flexShrink: 0,
          }}
        >
          <OrgDisplay imgKey={logoKey ? logoKey : null} collapsed={true} />
        </div>

        {/* Navigation container with HOME and division dropdowns */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flex: 1,
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* HOME Link */}
          <Link
            to={'/home'}
            style={{
              cursor: 'pointer',
              padding: '0 12px',
              color: 'rgba(255, 255, 255, 0.85)',
              display: 'flex',
              alignItems: 'center',
              height: '46px',
              textDecoration: 'none',
              fontSize: '14px',
            }}
          >
            HOME
          </Link>

          {/* Render divisions as dropdowns */}
          {getDivisionsToRender()
            .map((division) => buildDivisionMenu(division))
            .filter((item) => item !== null)}
        </div>
      </div>
    );
  }

  return (
    <>
      {!isMobile && (
        <Sider
          collapsible
          trigger={null}
          breakpoint="xl"
          collapsedWidth="80"
          collapsed={collapsed}
          onBreakpoint={(broken) => {
            toggleSideBar(broken);
          }}
          style={{
            position: 'sticky',
            top: 0,
            left: 0,
            height: '100vh',
            overflow: 'auto',
            backgroundImage: sidebarIsGradient ? sidebarBackground : 'none',
            backgroundColor: sidebarIsGradient ? 'transparent' : sidebarBackground,
            backgroundAttachment: 'fixed',
            backgroundSize: '100% 100vh',
          }}
        >
          <div className={collapsed ? 'custom-sidebar-color collapsed' : 'custom-sidebar-color'}>
            {/* {isSelfService === true && (
              <>
                {props.chatWootLoading === false && (
                  <ChatwootWidget
                    chatWootId={props.chatWootId}
                    currentUser={props.currentUser}
                  />
                )}
              </>
            )} */}
            <div style={collapsed ? null : logo}>
              <OrgDisplay imgKey={logoKey ? logoKey : null} collapsed={collapsed} />
            </div>
            <div>
              <Menu
                theme="dark"
                mode="inline"
                style={{
                  border: 'none',
                  marginBottom: '30px',
                }}
              >
                {renderSubCategoriesAndFeatures(
                  divisions,
                  features,
                  rootPath,
                  collapsed,
                  subMenuSelected,
                  setSubMenuSelected,
                  sidebarColor,
                  isSelfService,
                  billing,
                  orgLevel,
                  parentOrgLevel,
                  urlLink
                )}
              </Menu>
            </div>
          </div>
        </Sider>
      )}
    </>
  );
};

export default withRouter(Sidebar);
